export class GruppoTerritoriale {
  id: string;
  nomeGruppo: string;
  label: string;
  active?:boolean;
}
